import { z } from "zod";
import { IdType } from "./base.validator";
import { createdUser } from "./users.validator";

export const createdDepartment = z.object({
	id: IdType.nullable(),
	departmentName: z.string(),
	accountId: IdType.nullable(),

	headUser: createdUser
		.pick({ id: true, firstName: true, lastName: true })
		.nullable(),
});
